module.exports = __webpack_public_path__ + "static/media/cl.b98cd9bc.svg";